import { Box } from '@mui/system';
import React, { useState, useEffect, useRef, forwardRef } from 'react';

type ISvg = {
  name: string;
  size?: number | string;
  width?: number | string;
  height?: number | string;
  className?: string;
  marginTop?: number | string;
  marginBottom?: number | string;
  marginLeft?: number | string;
  marginRight?: number | string;
};

function Svg({
  name,
  size,
  width,
  height,
  className,
  marginBottom,
  marginTop,
  marginLeft,
  marginRight
}: ISvg) {
  const ImportedSvgRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const importIcon = async () => {
      try {
        const { default: SvgComp } = await import(`assets/svg/${name}.svg`);
        ImportedSvgRef.current = SvgComp;
      } finally {
        setLoading(false);
      }
    };
    importIcon();
  }, [name]);

  const { current: ImportedSvg } = ImportedSvgRef || {};

  return (
    <Box
      sx={{
        display: 'inline-block',
        '& svg': {
          height: height || size,
          width: width || size,
          verticalAlign: 'middle',
          marginTop: marginTop || 0,
          marginBottom: marginBottom || 0,
          marginLeft: marginLeft || 0,
          marginRight: marginRight || 0
        }
      }}
      className={className}
      data-testid={name}>
      {!loading && ImportedSvg && typeof ImportedSvg !== 'object' && (
        <ImportedSvg />
      )}
    </Box>
  );
}

Svg.defaultProps = {
  width: null,
  height: null,
  size: null,
  className: '',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0
};

function WrapperRef(props: any, _ref) {
  return <Svg {...props} />;
}

export default forwardRef(WrapperRef);
